module.exports = __webpack_public_path__ + "image-e29fb4a00642.png";